<template>
    <pc-capsule
        v-show="rows.length > 0"
        v-bind="capsuleBinder"
        has-body
        data-test-role="summary-capsule"
        v-on="capsuleListeners">
        <pc-loader v-bind:loading="isLoading">
            <project-summary-capsule-body
                v-bind:rows="rows"
                v-bind:is-loading="isLoading" />
        </pc-loader>
    </pc-capsule>
</template>

<script>
    import capsuleBase from "./_sharedCapsuleBase";
    import projectSummaryCapsuleBody from "./projectSummaryCapsuleBody.vue";

    export default {
        components: { projectSummaryCapsuleBody },
        extends: capsuleBase,
        props: {
            id: { type: String, required: false, default: "project-summary" },
            title: { type: String, required: false, default: "Project Summary" },
            model: { type: Object, required: true }
        },
        data() {
            return {
                legacyId: "project-summary-capsule",
                rows: this.model.RowDefinitions || [],
                isLoading: true
            };
        },
        created() {
            this.loadProjectSummary();
        },
        methods: {
            async loadProjectSummary() {
                const result = await this.$serviceControllers.ProjectSummary.GetProjectSummaryTable({
                    programPublicId: this.ProgramId,
                    projectPublicId: this.ProjectId,
                    summaryPageType: this.isAdminPage ? "AdminPage" : "LandingPage"
                });
                this.rows = result.Data.rowList;
                this.isLoading = false;
            }
        }
    };
</script>
